<template>
    <div>
        <el-table
            id="paidInvoiceTable"
            style="width: 100%"
            max-height="700"
            :data="invoices"
        >
            <el-table-column
                min-width="120"
                header-align="left"
                label="Actions"
            >
                <div slot-scope="{ row }" class="d-flex flex-column">
                    <base-button
                        class="mb-2"
                        type="default"
                        size="sm"
                        @click="showFiles(row.id)"
                    >
                        View Files
                    </base-button>
                </div>
            </el-table-column>
            <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :width="column.width"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :sortable="column.sortable"
                :formatter="column.formatter"
                :sort-method="column.sortMethod"
                :show-overflow-tooltip="true"
            />
        </el-table>
        <file-download-modal
            v-if="showFileDownloadModal"
            :invoice-id="selectedInvoiceID"
            @update:show="showFileDownloadModal = $event"
        />
    </div>
</template>

<script>
import moment from "moment-timezone";
import FileDownloadModal from "src/components/FileDownloadModal";

export default {
    name: "PaidInvoicesTable",
    components: { FileDownloadModal },
    props: {
        invoices: {
            type: Array,
            required: true,
        },
        excludeColumns: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            selectedInvoiceID: null,
            showFileDownloadModal: false,
        };
    },
    computed: {
        tableColumns() {
            let columns = [
                {
                    prop: "id",
                    label: "ID",
                    sortable: true,
                    width: 100,
                },
                {
                    prop: "customer_name",
                    label: "Customer",
                    sortable: true,
                    width: 250,
                },
                {
                    prop: "total",
                    label: "Total",
                    formatter: (row) => this.formatCurrency(row.total),
                    sortable: true,
                    width: 150,
                },
                {
                    prop: "payment_type",
                    label: "Payment Type",
                    width: 125,
                },
                {
                    prop: "interest",
                    label: "Interest Applied",
                    formatter: (row) =>
                        row.apply_interest
                            ? this.formatCurrency(row.interest_due)
                            : "--",
                    sortable: true,
                    width: 150,
                },
                {
                    prop: "interest_due",
                    label: "Interest Due",
                    formatter: (row) => this.formatCurrency(row.interest_due),
                    sortable: true,
                    width: 150,
                },
                {
                    prop: "delivery_log_id",
                    label: "Delivery Log",
                    sortable: true,
                    formatter: (row) =>
                        row.delivery_log_id === 0 ? "--" : row.delivery_log_id,
                    width: 150,
                },
                {
                    prop: "date",
                    label: "Delivery Date",
                    sortable: true,
                    sortMethod: (a, b) => new Date(b.date) - new Date(a.date),
                    formatter: (row) => this.formatDate(row.date),
                    width: 150,
                },
                {
                    prop: "paid_date",
                    label: "Paid Date",
                    sortable: true,
                    sortMethod: (a, b) =>
                        new Date(b.paid_date) - new Date(a.paid_date),
                    formatter: (row) => this.formatDate(row.paid_date),
                    width: 150,
                },
                {
                    prop: "due_date",
                    label: "Due Date",
                    sortable: true,
                    sortMethod: (a, b) =>
                        new Date(b.dueDate) - new Date(a.dueDate),
                    formatter: (row) => this.formatDate(row.dueDate),
                    width: 150,
                },
                {
                    prop: "last4",
                    label: "Last 4",
                    width: 125,
                },
                {
                    prop: "notes",
                    label: "Notes",
                    width: 250,
                },
            ];
            // eslint-disable-next-line max-len
            columns = columns.filter(
                (column) =>
                    this.excludeColumns.findIndex(
                        (hide) => hide === column.label,
                    ) === -1,
            );
            return columns;
        },
    },
    methods: {
        showFiles(invoiceID) {
            this.selectedInvoiceID = invoiceID;
            this.showFileDownloadModal = true;
        },
        formatDate(date) {
            if (date) {
                return moment(date).format("MM/DD/YYYY");
            }
            return "--";
        },
        formatCurrency(value) {
            const formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            });
            return formatter.format(value);
        },
    },
};
</script>
